import { EventEmitter, ViewChildren } from '@angular/core';
import { Output } from '@angular/core';
import { Input } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
@Component({
  selector: 'app-reportfilter',
  templateUrl: './reportfilter.component.html',
  styleUrls: ['./reportfilter.component.css']
})
export class ReportfilterComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

 


  empColl: any = [];
  doctypeColl: any = [];
  groupColl: any = [];

  @Input() formname: string = "";

  @Input() empid: any = null;
  @Input() doctypeid: any = null;
  @Input()  filtergroupby: string = "";

  @Output() emitData = new EventEmitter();


  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private activeModal: NgbActiveModal,) {

  }




  ngOnInit() {
    try {

      this.fngetEmp();
      this.fngetDoctype();
      this.fnGroupby();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  ngAfterViewInit() {
    ////this.firstipcontrol.first.nativeElement.focus();
  }

  fnGroupby(){
    this.groupColl = [];

    this.groupColl.push({value:'DESIGNATION',displayname:'Designation'});
    this.groupColl.push({value:'PAYROLL',displayname:'Payroll'});
    this.groupColl.push({value:'DEPARTMENT',displayname:'Department'});
    this.groupColl.push({value:'BRANCH',displayname:'Branch'});
  }


  fngetEmp() {
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.empColl = res.json().result;
            console.log(this.empColl)
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetDoctype() {
    var data = {
      'doctypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getDocType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.doctypeColl = res.json().result;
            console.log(this.doctypeColl)
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnApplyFilter() {
    try {
      var data = {
        status: 'DONE',
        empid: this.empid,
        empname: this.fnGetEmpname(),
        doctypeid: this.doctypeid,
        doctypename: this.fnGetDoctypename(),
        filtergroupby:this.filtergroupby,
      }
      this.emitData.emit(data);
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnGetEmpname() {
    var empname = "";
    for (let abo of this.empColl) {
      if (this.empid === abo.empid) {
        empname = abo.empname;
      }
    }

    return empname
  }
  fnGetDoctypename() {
    var doctypename = "";
    for (let abo of this.doctypeColl) {
      if (this.doctypeid === abo.doctypeid) {
        doctypename = abo.doctypename;
      }
    }

    return doctypename
  }
  fnGetGroupby() {
    var displayname = "";
    for (let abo of this.groupColl) {
      if (this.filtergroupby === abo.value) {
        displayname = abo.displayname;
      }
    }

    return displayname
  }
  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }



}
